import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CxSchedularContainerComponent } from './cx-schedular.component';
import { CxSchedularListComponent } from './cx-schedular-list/cx-schedular-list.component';
import { CxSchedularCreatorComponent } from './cx-schedular-creator/cx-schedular-creator.component';
import { CxSchedularService } from './cx-schedular.service';
import { DropdownModule } from '@shared/modules/dropdown/dropdown';
// import { ChipsModule } from 'primeng/chips';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from '@shared/modules/calendar/calendar';
import { ChipsModule } from '../chips/chips';

@NgModule({
  declarations: [ 
    CxSchedularContainerComponent, 
    CxSchedularListComponent, 
    CxSchedularCreatorComponent 
  ],
  imports: [
    FormsModule,
    ChipsModule,
    DropdownModule,
    CommonModule,
    CalendarModule,
  ],
  providers: [ CxSchedularService ], 
  exports: [
    CxSchedularContainerComponent, 
    CxSchedularListComponent, 
    CxSchedularCreatorComponent 
  ]
})
export class CxSchedularModule { }
